import { Component, EventEmitter, OnInit, Input, Output, ViewChild } from '@angular/core';
import { Router }            from '@angular/router';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as enums from '../../enums/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'
import * as util from '../../util/index'

import { BaseRequestComponent }                from '../../baseclasses/BaseRequest.component';

//components
import {UserInfoComponent} from '../../components/ControlGroups/UserInfo.component';
import {CompletionDetailsComponent} from '../../components/ControlGroups/CompletionDetails.component';
import {GeneralDetailsComponent} from '../../components/ControlGroups/GeneralDetails.component';
import {ContactDetailsComponent} from '../../components/ControlGroups/ContactDetails.component';
import {CustomerRequirementsComponent} from '../../components/ControlGroups/CustomerRequirements.component';
import {VendorDetailsComponent} from '../../components/ControlGroups/VendorDetails.component';
import {EquipmentDetailsComponent} from '../../components/ControlGroups/EquipmentDetails.component';
import {AddressComponent} from '../../components/ControlGroups/Address.component';
import {NotesComponent} from '../../components/ControlGroups/Notes.component';
import {RequestHeaderComponent} from '../../components/Controls/RequestHeader.component';
import {ChangePhoneNumberDialogComponent} from '../../components/Employees/ChangePhoneNumberDialog.component';

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-equipment-move-request',
  templateUrl: './CreateEquipmentMoveRequest.component.html'
})
export class CreateEquipmentMoveRequestComponent extends BaseRequestComponent {

    userInfo: ent.UserInfo;
    requestToSave: ent.Request;

    defaultActivityReasonID: number;

    activityReasonFilter: filters.ActivityReasonFilter;

    @ViewChild(UserInfoComponent) userInfoComponent: UserInfoComponent;
    @ViewChild(CompletionDetailsComponent) completionDetailsComponent: CompletionDetailsComponent;
    @ViewChild(GeneralDetailsComponent) generalDetailsComponent: GeneralDetailsComponent;
    @ViewChild(ContactDetailsComponent) contactDetailsComponent: ContactDetailsComponent;
    @ViewChild(CustomerRequirementsComponent) customerRequirementsComponent: CustomerRequirementsComponent;
    @ViewChild(VendorDetailsComponent) vendorDetailsComponent: VendorDetailsComponent;
    @ViewChild(EquipmentDetailsComponent) equipmentDetailsComponent: EquipmentDetailsComponent;
    @ViewChild(AddressComponent) addressComponent: AddressComponent;
    @ViewChild(NotesComponent) notesComponent: NotesComponent;
    @ViewChild(RequestHeaderComponent) requestHeaderComponent: RequestHeaderComponent;
    @ViewChild(ChangePhoneNumberDialogComponent) changePhoneNumberDialogComponent: ChangePhoneNumberDialogComponent;

    constructor() 
    { 
        super();
        this.activityReasonFilter = new filters.ActivityReasonFilter();
        this.activityReasonFilter.RequestTypeID = enums.RequestTypeEnum.EquipmentMove;
        this.defaultActivityReasonID = enums.ActivityReasonEnum.EquipmentMove_NewLocationInSameStore;
    }

    ngOnInit(): void {
        if (!this.authenticationService.checkLoginStatus())
        {
            this.router.navigate(['login']);
        }

        this.userInfo = this.authenticationService.getUserInfo();
        
    }

    getRequestTypeID(){
        return enums.RequestTypeEnum.EquipmentMove;
    }

    onSaveClick(event: any){
        
        this.requestToSave = {
            ID: this.requestID,
            RequestTypeID: enums.RequestTypeEnum.EquipmentMove,
            RequestStatusID: this.request ? this.request.RequestStatusID : enums.RequestStatusEnum.Open,
            GeneralInfo: this.generalDetailsComponent.generalInfo,
            ContactInfos: [this.contactDetailsComponent.contactInfo],
            CustomerRequirementInfo: this.customerRequirementsComponent.customerRequirementInfo,
            VendorInfo: this.vendorDetailsComponent.vendorInfo,
            OtherInfo: this.notesComponent.otherInfo,
            EmployeeID: this.userInfoComponent.userInfo.Employee.ID, 
            SalesOfficeID: util.RequestUtil.GetSalesOfficeID(this.userInfoComponent, this.generalDetailsComponent),
            PhoneNumber: this.userInfoComponent.userInfo.Employee.PhoneNumber,
            RequestDate: new Date()
        };

        util.RequestUtil.LoadCompletionDetails(this.requestToSave, this.completionDetailsComponent);

        this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityStartString = this.customerRequirementsComponent.getStartTime();
        this.requestToSave.CustomerRequirementInfo.CustomerAvailabilityEndString = this.customerRequirementsComponent.getEndTime();
        
        if (this.userInfoComponent.request.PhoneNumber){
            this.requestToSave.PhoneNumber = this.userInfoComponent.request.PhoneNumber;
        }
        this.requestToSave.EquipmentLineItems = this.equipmentDetailsComponent.equipmentLineItemGrid.lineItems;

        this.requestToSave.RequestDays = util.RequestUtil.LoadRequestDays(this.requestToSave, this.customerRequirementsComponent.dayOfWeekMultiSelectComponent, enums.DayType.CustomerNotAvailable);

        this.requestToSave.Addresses = [];
        if (util.AddressUtil.isAddressPopulated(this.addressComponent.address)){
            this.addressComponent.address.AddressTypeID = enums.AddressType.Equipment;
            this.requestToSave.Addresses.push(this.addressComponent.address);
        }

        this.requestToSave.RequestCustomers = util.RequestUtil.LoadRequestCustomersFromGrid(this.requestToSave, this.generalDetailsComponent.requestCustomerGridComponent, enums.RequestCustomerTypeEnum.AppliesTo);

        this.requestToSave.RequestEquipmentClasses = util.RequestUtil.LoadRequestEquipmentClassesFromEquipmentLineItems(this.requestToSave.EquipmentLineItems);

        this.changePhoneNumberDialogComponent.promptToUpdatePassword(this.requestToSave.PhoneNumber, this.userInfoComponent.userInfo.Employee.PhoneNumber, this.userInfoComponent.userInfo.Employee.ID);
    }
    
    customerNumberChanged(event: string) {
        this.equipmentDetailsComponent.equipmentLineItemGrid.customerNumber = event;
    }
    
    onYes(event: ent.Response){
        this.requestHeaderComponent.handleResponse(event);
        this.saveRequest(this.requestToSave);
    }

    onNo(event: any){
        this.saveRequest(this.requestToSave);
    }

    onCancel(event: any){
        //do nothing
    }

    onSubmitClick(event: any){
        this.getRequest(true);
    }

    onEquipmentLineItemsChanged(lineItems: ent.EquipmentLineItem[]){
        this.customerRequirementsComponent.setEquipmentClasses(lineItems);
    }



}